/**
 * Cash Action Creators
 */
import { Kushki } from "@kushki/js";
import { ErrorResponse } from "@kushki/js/lib/types/error_response";
import { PayoutsCashTokenRequest } from "@kushki/js/lib/types/payouts_cash_request";
import { setErrorMessage } from "components/Error/store/Actions";
import {
  hideOverlay,
  showOverlay,
} from "components/OverLay/store/ActionCreators";
import { Actions } from "containers/PayoutsCash/store/Actions";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { CajitaStore, IInputProps } from "root/store/CajitaStore";
import { updateDisableButton } from "root/store/Reducer";
import { IPayoutsCashActionCreator } from "types/payouts_cash_action_creator";
import { IPayoutsCashFormProps } from "types/payouts_cash_form_props";
import { TokenResponse } from "types/remote/token_response";

function getStatusValidity(state: IPayoutsCashFormProps): boolean {
  let isValid: boolean = true;

  const inputs: string[] = [
    "nameInput",
    "lastNameInput",
    "identificationInput",
    "email",
  ];

  for (const inputName of inputs) {
    if (state[inputName].rules.required)
      isValid =
        state[inputName].valid && isValid && state[inputName].value !== "";
    if (!state[inputName].rules.required && state[inputName].value !== "")
      isValid = state[inputName].valid && isValid;
  }

  return isValid;
}

const inputAction: (payload: IInputProps) => IPayoutsCashActionCreator = (
  payload: IInputProps
): IPayoutsCashActionCreator => ({
  type: Actions.UPDATE_PAYOUTS_CASH_INPUT,
  input: payload,
});

const disablePayoutCashAction: () => IPayoutsCashActionCreator = (): IPayoutsCashActionCreator => ({
  type: Actions.DISABLE_PAYOUTS_CASH_FORM,
});

const changeStatus: () => IPayoutsCashActionCreator = (): IPayoutsCashActionCreator => ({
  type: Actions.SWITCH_PAYOUTS_CASH_VALIDITY,
});

const setDirty: (payload: IInputProps) => IPayoutsCashActionCreator = (
  payload: IInputProps
): IPayoutsCashActionCreator => ({
  type: Actions.SET_PAYOUTS_CASH_INPUT_DIRTY,
  input: payload,
});

const updatePayoutCashToken: (payload: string) => IPayoutsCashActionCreator = (
  payload: string
): IPayoutsCashActionCreator => ({
  type: Actions.SET_PAYOUTS_CASH_TOKEN,
  token: payload,
});

function updateInput(
  payload: IInputProps
): ThunkAction<void, CajitaStore, undefined, IPayoutsCashActionCreator> {
  return (
    dispatch: ThunkDispatch<CajitaStore, undefined, IPayoutsCashActionCreator>,
    getState: () => CajitaStore
  ): void => {
    dispatch(inputAction(payload));
    const state: IPayoutsCashFormProps = getState().payouts_cash;
    const status: boolean = getStatusValidity(state);

    if (state.isValid !== status) dispatch(changeStatus());
  };
}

function getPayoutCashToken(
  body: PayoutsCashTokenRequest
): ThunkAction<void, CajitaStore, undefined, IPayoutsCashActionCreator> {
  return (dispatch: Function, getState: () => CajitaStore): void => {
    const kushki: Kushki = getState().config.kushkiJS as Kushki;

    dispatch(updateDisableButton(true));
    dispatch(showOverlay());
    kushki.requestPayoutsCashToken(
      body,
      (response: TokenResponse | ErrorResponse) => {
        if ("token" in response)
          dispatch(updatePayoutCashToken(response.token));
        else {
          dispatch(setErrorMessage(response.message));
          dispatch(hideOverlay());
        }
        dispatch(updateDisableButton(false));
      }
    );
  };
}

function updatePayoutCashDocumentType(
  documentType: string
): ThunkAction<void, CajitaStore, undefined, IPayoutsCashActionCreator> {
  return (
    dispatch: ThunkDispatch<CajitaStore, undefined, IPayoutsCashActionCreator>,
    _getState: () => CajitaStore
  ): void => {
    const updateDocumentType: IPayoutsCashActionCreator = {
      type: Actions.UPDATE_DOCUMENT_TYPE_NUMBER,
      token: documentType,
    };

    dispatch(updateDocumentType);
  };
}

export {
  setDirty,
  updateInput,
  getPayoutCashToken,
  changeStatus,
  disablePayoutCashAction,
  updatePayoutCashDocumentType,
};



// WEBPACK FOOTER //
// ./src/containers/PayoutsCash/store/ActionCreators.tsx